import { render, staticRenderFns } from "./Mailgun.vue?vue&type=template&id=1ff9b0dc&scoped=true"
import script from "./Mailgun.vue?vue&type=script&lang=js"
export * from "./Mailgun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9b0dc",
  null
  
)

export default component.exports